export const SET_VIEW = 'SET_VIEW';
export const SET_LOADING = 'SET_LOADING';
export const SET_LOADING_SET_AGREEMENT = 'SET_LOADING_SET_AGREEMENT';
export const SET_LOADING_DUE_DATE = 'SET_LOADING_DUE_DATE';
export const SET_LOADING_DASHBOARD_DEBTS = 'SET_LOADING_DASHBOARD_DEBTS';
export const SET_NOT_LOGGED_TEXT = 'SET_NOT_LOGGED_TEXT';

export const SET_DOC_NUMBER = 'SET_DOC_NUMBER';
export const SET_DEBTOR_ID = 'SET_DEBTOR_ID';
export const SET_IP_USER = 'SET_IP_USER';
export const SET_USER_ADM_ID = 'SET_USER_ADM_ID';
export const SET_CLIENT_ID_BOTICARIO = 'SET_CLIENT_ID_BOTICARIO';
export const SET_CLIENT_ID_EUDORA = 'SET_CLIENT_ID_EUDORA';

export const SET_DEBTS_BOTICARIO = 'SET_DEBTS_BOTICARIO';
export const SET_DEBTS_EUDORA = 'SET_DEBTS_EUDORA';
export const SET_OFFERS_BOTICARIO = 'SET_OFFERS_BOTICARIO';
export const SET_OFFERS_EUDORA = 'SET_OFFERS_EUDORA';
export const SET_OFFERS_NEGOTIATION_BOTICARIO = 'SET_OFFERS_NEGOTIATION_BOTICARIO';
export const SET_OFFERS_NEGOTIATION_EUDORA = 'SET_OFFERS_NEGOTIATION_EUDORA';
export const SET_MAIN_OFFERS_BOTICARIO = 'SET_MAIN_OFFERS_BOTICARIO';
export const SET_MAIN_OFFERS_EUDORA = 'SET_MAIN_OFFERS_EUDORA';
export const SET_SELECTED_OFFER_BOTICARIO = 'SET_SELECTED_OFFER_BOTICARIO';
export const SET_SELECTED_OFFER_EUDORA = 'SET_SELECTED_OFFER_EUDORA';

export const SET_DEBT_BOTICARIO = 'SET_DEBT_BOTICARIO';
export const SET_LATE_DATE_BOTICARIO = 'SET_LATE_DATE_BOTICARIO';
export const SET_LATE_DATE_EUDORA = 'SET_LATE_DATE_EUDORA';
export const SET_DUE_DATE_BOTICARIO = 'SET_DUE_DATE_BOTICARIO';
export const SET_DUE_DATE_EUDORA = 'SET_DUE_DATE_EUDORA';
export const SET_DUE_DATES_BOTICARIO = 'SET_DUE_DATES_BOTICARIO';
export const SET_DUE_DATES_EUDORA = 'SET_DUE_DATES_EUDORA';

export const SET_PREVENTIVE_BOTICARIO = 'SET_PREVENTIVE_BOTICARIO';
export const SET_PREVENTIVE_EUDORA = 'SET_PREVENTIVE_EUDORA';
export const SET_HAS_AGREEMENT_BOTICARIO = 'SET_HAS_AGREEMENT_BOTICARIO';
export const SET_HAS_AGREEMENT_EUDORA = 'SET_HAS_AGREEMENT_EUDORA';
export const SET_HAS_NO_BOTICARIO_DATA = 'SET_HAS_NO_BOTICARIO_DATA';
export const SET_HAS_NO_EUDORA_DATA = 'SET_HAS_NO_EUDORA_DATA';
export const ADD_VIEWED_OFFERS_BOTICARIO_LOG_KEY = 'ADD_VIEWED_OFFERS_BOTICARIO_LOG_KEY';
export const ADD_VIEWED_OFFERS_EUDORA_LOG_KEY = 'ADD_VIEWED_OFFERS_EUDORA_LOG_KEY';

export const SET_AGREEMENT = 'SET_AGREEMENT';
export const SET_PREPARE_AGREEMENT = 'SET_PREPARE_AGREEMENT';
export const SET_SELECTED_PAYMENT_METHOD = 'SET_SELECTED_PAYMENT_METHOD';

export const SET_LOADING_AGREEMENT_BILL = 'SET_LOADING_AGREEMENT_BILL';
export const SET_AGREEMENT_BILL_SCREEN = 'SET_AGREEMENT_BILL_SCREEN';
export const SET_AGREEMENT_BILL_SELECTED_OPTION = 'SET_AGREEMENT_BILL_SELECTED_OPTION';
export const CLEAR_AGREEMENT_BILL_SCREEN = 'CLEAR_AGREEMENT_BILL_SCREEN';

export const SET_TITLES_EUDORA_NEGOTIATION = 'SET_TITLES_EUDORA_NEGOTIATION';

export const RESET_NEGOTIATION_FLOW = 'RESET_NEGOTIATION_FLOW';
export const RESET_NEGOTIATION_SESSION = 'RESET_NEGOTIATION_SESSION';
